import type { MessageSuggestion, SentimentCues } from "@expert/shared-types";

import { type GaiaWebSocketResponse, gaiaWsEventBus } from "@expert/gaia";
import { useEffect } from "react";

import { getRootDispatcher } from "@/analytics";

export const useSentimentListener = (
    setSentiment: (value: React.SetStateAction<SentimentCues | undefined>) => void,
) => {
    useEffect(() => {
        const subscription = gaiaWsEventBus.on("gaia_ws_message-suggestion", ({ body }: GaiaWebSocketResponse) => {
            const message = body as MessageSuggestion;
            const sentiment = message.suggestion.cues?.findLast((cue) => cue.type === "SENTIMENT");
            if (sentiment) {
                void getRootDispatcher().dispatchBusinessEvent("CustomerCueDetected", {
                    detectionSource: "GAIA",
                    cueType: sentiment.type,
                    cueName: sentiment.name,
                });
                setSentiment(sentiment);
            }
        });
        return () => subscription();
        // oxlint-disable-next-line exhaustive-deps
    }, []);
};
